import { GetCssClassNamesOption, ImageSrc } from '@ardoq/data-model';
import { ViewIds } from '@ardoq/api-types';

export const MATERIAL_ICONS_DEFAULT_FONT_SIZE = 24;
export const VIEW_SCROLLBAR_WIDTH_CSS_VARIABLE = '--view-scrollbar-width';

export const GET_CSS_BACKGROUND_OPTIONS: GetCssClassNamesOption = Object.freeze(
  {
    useAsBackgroundStyle: true,
  }
);

/**
 * The component's own color, rather than the lightened background variant
 * `GET_CSS_BACKGROUND_OPTIONS` asks for. What the newer views fill with.
 */
export const TRUE_COLOR_OPTIONS: GetCssClassNamesOption = Object.freeze({
  useAsBackgroundStyle: false,
});

export const EXCLUDE_UNUSED_TAGS = 'Exclude unused tags';
export const HIDE_EMPTY_VALUES = 'Hide empty values';

const thumbnails: {
  [key in ViewIds]?: ImageSrc;
} = {
  [ViewIds.SWIMLANE]: `swimlane.jpg`,
  [ViewIds.DEPWHEEL]: 'dependencyWheel.jpg',
  [ViewIds.TREEMAP]: 'treemap.jpg',
  [ViewIds.TAGSCAPE]: 'tagscape.jpg',
  [ViewIds.COMPONENTTREE]: 'componentTree.jpg',
  [ViewIds.NETWORK]: 'networkView.jpg',
  [ViewIds.RELATIONSHIPS_3]: 'relationshipsView3.jpg',
  [ViewIds.TABLEVIEW]: 'tableview.jpg',
  [ViewIds.SPIDER]: 'spiderChart.jpg',
  [ViewIds.ROADMAP]: 'product_roadmap.jpg',
  [ViewIds.DEPENDENCY_MAP_2]: 'dependencyMap2.jpg',
  [ViewIds.DEPMATRIX]: 'dependencyMatrix.jpg',
  [ViewIds.REFERENCETABLE]: 'reference-table.jpg',
  [ViewIds.BUBBLE]: 'bubbles.jpg',
  [ViewIds.CAPABILITY_MAP]: 'capability-map.jpg',
  [ViewIds.TIMELINE]: 'timeline.jpg',
  [ViewIds.BLOCK_DIAGRAM]: 'blockDiagram.jpg',
  [ViewIds.PAGESVIEW]: 'Pages-view-2.jpg',
  [ViewIds.COMPONENT_MATRIX]: 'componentMatrix.jpg',
  [ViewIds.COMPONENT_MATRIX_2]: 'componentMatrix2-slidePreview.png',
  [ViewIds.ISOMETRIC_BLOCK_DIAGRAM]: 'blockDiagram.jpg',
  [ViewIds.BLOCKS]: 'blockDiagram.jpg',
  [ViewIds.MODERNIZED_BLOCK_DIAGRAM]: 'blockDiagram.jpg',
};

export const getViewThumbnailSrc = (viewId: ViewIds) =>
  thumbnails[viewId] ? `img/viewsExample/${thumbnails[viewId]}` : '';

export const NO_BREAK_SPACE = '\xa0';
export const MINIMUM_READABLE_FONT_SIZE = 6;
export const MAXIMUM_DATA_LABEL_FONT_SIZE = 24;

/** all relative luminances beneath this value are considered "dark." */
export const LUMINANCE_THRESHOLD = 0.179;
